export default function Indicator({ value, children }) {
    return (
        <div className="indicator">
            {value > 0 && <span className="p-1 indicator-item right-1.5 top-1.5 badge badge-primary text-xs min-w-[20px]">{value}</span>}
            {children}
        </div>
    );
}